export default __webpack_public_path__ + "assets/images/44aa81e021f6978294dfd54d6a9d40c9.png";